<app-dropdown class="w-100" (blurDropdown)="onBlurDropDown()" [hasError]="!!control?.touched && !control?.valid">
  <app-dropdown-title>{{ title }}</app-dropdown-title>
  <ng-content></ng-content>
</app-dropdown>
